import { Shortlist } from "PFTypes";

export const displayShortlistReasons = (reasons: Shortlist["reasons"] = {}) => {
  const toReturn = reasons?.list ? [...reasons.list] : [];

  if (reasons?.other) {
    toReturn.push(reasons.other);
  }

  return toReturn.join(", ");
};
